import eBayButton from '<ebay-button>';
import eBayFakeLink from '<ebay-fake-link>';

$ {
  const {
    accessibilityText,
    action = {},
    containsHtml,
    disabled,
    id,
    noTag,
    sid,
    span,
    styles,
    tag,
    text,
    textSpans,
    renderAsFakeLink
  } = input;
  const isButton = action.type === 'OPERATION';
  const isLink = action.type === 'NAV';
  const tagName = isButton ? (renderAsFakeLink ? eBayFakeLink : eBayButton) : (isLink ? 'a' : tag || 'span');
  const isBodyOnly = (noTag || (!span || textSpans) && !isButton && !isLink && !tag);
}

<${!isBodyOnly ? tagName : null}
  type=(isButton ? (/^(reset|submit)$/.test(action.name) && action.name || 'button') : false)
  id=id
  class=[
    'textual-display',
    input.class,
    (styles || []).map(style => style.toLowerCase())
  ]
  for=input.for
  href=(isLink && action.URL)
  on-click((isLink || isButton) && 'clickHandler')
  target=(isLink && action.name === 'newWindow' && '_blank')
  disabled=(isButton && (disabled || action.disabled))
  _sp=sid
  priority=(isButton && input.priority)
>
  <if(textSpans)>
    <for|textSpan| of=textSpans>
      <fe-textual-display
        model=textSpan
        class=input.class
        span=(span || textSpan.styles)
        contains-html=containsHtml
        priority=input.priority
        render-as-fake-link=renderAsFakeLink
        on-click('emit', 'click') />
    </for>
  </if>
  <else-if(containsHtml)>
    $!{text}
  </else-if>
  <else>
    ${text}
  </else>

  <if(accessibilityText)>
    <fe-textual-display
      class="clipped"
      text=accessibilityText
      span />
  </if>
</>
